import React from "react";
import { TimeSeriesItem } from "~/modules/token_timeseries/types";
import { ApiQuery, ApiQueryEndpoints } from "~/modules/filters/types";
import { useApiQuery } from "~/modules/filters/components/useApiQuery";

// // // //

/**
 * Main component that conditionally renders the appropriate fetcher
 */
function TimeseriesQuery(props: {
    endpoint: ApiQueryEndpoints;
    query: ApiQuery;
    children: (childProps: {
        data: TimeSeriesItem[];
        loading: boolean;
        error?: Error;
    }) => React.ReactNode;
}) {
    const { children, query, endpoint } = props;

    const timeseriesReq = useApiQuery({
        endpoint,
        query,
    });

    return (
        <>
            {children({
                loading: timeseriesReq.isLoading,
                data: timeseriesReq.data ? timeseriesReq.data.results : [],
                error: timeseriesReq.error as unknown as Error | undefined,
            })}
        </>
    );
}

/**
 * Main component that conditionally renders the appropriate fetcher
 */
export function TimeSeriesFetcher(props: {
    endpoint: ApiQueryEndpoints | null;
    query: ApiQuery;
    children: (childProps: {
        data: TimeSeriesItem[];
        loading: boolean;
        error?: Error;
    }) => React.ReactNode;
}) {
    const { children, query, endpoint } = props;

    // Fallback for null endpoint
    if (endpoint === null) {
        return (
            <>
                {children({
                    loading: false,
                    data: [],
                    error: new Error(
                        `ApiQueryEndpoint Not Supported: ${endpoint}`,
                    ),
                })}
            </>
        );
    }

    return (
        <TimeseriesQuery {...props} endpoint={endpoint as ApiQueryEndpoints} />
    );
}
